import { useEffect } from 'react';
import { hasStoredConsent } from '../utils/consentAwareLoader';

const STORAGE_KEY = 'pendingAffiliateCookieCode';

function writeAffiliateCookie(code: string): void {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 30);
  document.cookie = `affiliateReferralCode=${code}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
  sessionStorage.removeItem(STORAGE_KEY);
}

/**
 * Resolves a pending affiliate referral cookie set by ReferralTrackingPage when
 * the user had not yet granted functional consent at the time of the referral visit.
 *
 * Runs once on app mount. If consent is already stored, writes the cookie
 * immediately. Otherwise registers a one-time listener for the consent event.
 */
export function usePendingAffiliateCookie(): void {
  useEffect(() => {
    const pending = sessionStorage.getItem(STORAGE_KEY);
    if (!pending) return;

    if (hasStoredConsent('functional')) {
      writeAffiliateCookie(pending);
      return;
    }

    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (detail?.categories?.functional) {
        const code = sessionStorage.getItem(STORAGE_KEY);
        if (code) writeAffiliateCookie(code);
        window.removeEventListener('lookbel:consent-updated', handler);
      }
    };

    window.addEventListener('lookbel:consent-updated', handler);
    return () => window.removeEventListener('lookbel:consent-updated', handler);
  }, []);
}
